<div class="warp-active-toggle">
  <p translate>questionBoard.edit.formatYYYY/MM</p>
  <que-toggle [toggleState]="questionForm.controls.formatDate.value == 'YYYY/MM'"
    (toggleEvent)="markFormatDate($event)"></que-toggle>
</div>